/** @jsxImportSource @emotion/react */
import { useDrawer } from '@/hooks/drawer.hook';
import { css } from '@emotion/react';
import { ReactNode } from 'react';

type DrawerProps = {
  open: boolean;
  children: ReactNode;
};

export default function Drawer({ open, children }: DrawerProps) {
  const { closeDrawer } = useDrawer();
  return (
    <>
      {open && <div css={overlayStyle} onClick={closeDrawer} />}
      <div css={drawerStyle(open)}>
        <div css={drawerContentStyle}>{children}</div>
      </div>
    </>
  );
}

const drawerStyle = (open: boolean) => css`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  max-width: 60rem;
  border-top: 1px solid var(--light-back-color);
  background-color: var(--white-color);
  transform: ${open ? 'translateX(0)' : 'translateX(100%)'};
  transition: 0.3s all;
  z-index: 100;
  overflow: auto;
`;

const drawerContentStyle = css`
  padding: 1.6rem;
`;
const overlayStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d9d9d980; /* Màu đen với độ trong suốt */
  z-index: 100; /* Đặt z-index thấp hơn drawer */
`;
